// src/e2ee/session.ts

import { chacha20poly1305 } from '@noble/ciphers/chacha';

/**
 * E2EE session for encrypting/decrypting terminal I/O
 */
export class E2EESession {
  private sessionKey: Uint8Array;

  constructor(sessionKey: Uint8Array) {
    this.sessionKey = sessionKey;
  }

  /**
   * Encrypt plaintext with random nonce
   */
  encrypt(plaintext: Uint8Array): { nonce: Uint8Array; ciphertext: Uint8Array } {
    const nonce = crypto.getRandomValues(new Uint8Array(12));
    const cipher = chacha20poly1305(this.sessionKey, nonce);
    const ciphertext = cipher.encrypt(plaintext);
    return { nonce, ciphertext };
  }

  /**
   * Decrypt ciphertext with provided nonce
   */
  decrypt(nonce: Uint8Array, ciphertext: Uint8Array): Uint8Array {
    const cipher = chacha20poly1305(this.sessionKey, nonce);
    return cipher.decrypt(ciphertext);
  }

  /**
   * Securely dispose of session key
   */
  dispose(): void {
    this.sessionKey.fill(0);
  }
}
